import { useState, useEffect } from "react";

export default function BillingDetails({ collapsed }) {
  const [currentPlan, setCurrentPlan] = useState({
    name: "Starter Plan",
    price: "$10/month",
  });
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Simulated payment data
    const mockPayments = Array.from({ length: 17 }, (_, i) => ({
      date: `2025-0${(i % 6) + 1}-01`,
      amount: "$10.00",
      status: "Paid",
      invoiceUrl: `https://example.com/invoice-${i + 1}.pdf`,
    }));
    setPaymentHistory(mockPayments);
  }, []);

  const totalPages = Math.ceil(paymentHistory.length / itemsPerPage);
  const paginatedPayments = paymentHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div
      className={`transition-all duration-300 px-6 py-10 ${
        collapsed ? "ml-16" : "ml-72"
      }`}
    >
      <h1 className="text-2xl font-bold text-gray-800 mb-6">
        Billing Overview
      </h1>

      {/* Current Plan Section */}
      <div className="bg-white shadow rounded-xl p-6 mb-10 border border-gray-200">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">
              Current Plan
            </h2>
            <p className="text-base text-gray-700">
              {currentPlan.name} –{" "}
              <span className="font-medium text-indigo-600">
                {currentPlan.price}
              </span>
            </p>
          </div>
          <button
            onClick={() => alert("Redirect to upgrade")}
            className="text-sm font-medium text-indigo-600 hover:text-indigo-800"
          >
            Upgrade Plan
          </button>
        </div>
      </div>

      {/* Payment History Section */}
      <div className="bg-white shadow rounded-xl p-6 border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Payment History
          </h2>
          <div className="text-sm">
            <label className="mr-2 text-gray-600">Items per page:</label>
            <select
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1); // Reset to first page
              }}
              className="border border-gray-300 rounded-md px-2 py-1 text-sm"
            >
              {[5, 10, 20].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
        </div>

        {paginatedPayments.length === 0 ? (
          <p className="text-sm text-gray-500">No payment records found.</p>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-left text-gray-700">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-2 font-medium">Date</th>
                    <th className="px-4 py-2 font-medium">Amount</th>
                    <th className="px-4 py-2 font-medium">Status</th>
                    <th className="px-4 py-2 font-medium">Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedPayments.map((entry, i) => (
                    <tr
                      key={i}
                      className="border-b border-gray-100 hover:bg-gray-50"
                    >
                      <td className="px-4 py-3">{entry.date}</td>
                      <td className="px-4 py-3">{entry.amount}</td>
                      <td className="px-4 py-3">{entry.status}</td>
                      <td className="px-4 py-3">
                        <a
                          href={entry.invoiceUrl}
                          download
                          className="inline-block px-3 py-1 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
                        >
                          Download PDF
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex justify-end space-x-2 text-sm">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Previous
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => goToPage(i + 1)}
                  className={`px-3 py-1 border rounded-md ${
                    currentPage === i + 1
                      ? "bg-indigo-600 text-white"
                      : "hover:bg-gray-100"
                  }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
